/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./VfbSelect.vue?vue&type=template&id=9433400c&scoped=true&"
import script from "./VfbSelect.vue?vue&type=script&lang=js&"
export * from "./VfbSelect.vue?vue&type=script&lang=js&"
import style0 from "./VfbSelect.vue?vue&type=style&index=0&id=9433400c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9433400c",
  null
  
)

export default component.exports